import Vue from 'vue'
import Message from './message'

const defaults = {
  visible: false,
  content: null,
  duration: 3,
  closable: false,
  top: 20
}

const MessageVueConstrutor = Vue.extend(Message)

MessageVueConstrutor.prototype.close = function(){
  var vm = this;
  if (vm.$el && vm.$el.parentNode) {
    vm.$el.parentNode.removeChild(vm.$el);
  }
    this.$destroy();
  vm.visible = false;
}

const MessageBox = ( options = {} ) => {
  if (Vue.prototype.$isServer) return;
  options = Object.assign({}, defaults, options);
  let instance = new MessageVueConstrutor({
    el: document.createElement('div'),
    data: options
  });
  if(!instance.content){return false}
    document.body.appendChild(instance.$el);
    Vue.nextTick(() => {
      instance.visible = true;
      // if duration is 0 means can't close
      if(instance.duration!=0){
        setTimeout(function(){
          instance.close();
        },options.duration * 1000)
      }
    });
    return instance;
}

export default MessageBox